<template>
    <div class="operator-bar-wrapper clr">
        <div class="operator-box">
            <div class="opeat-l time-box">
                <el-date-picker
                    v-model="dates"
                    type="datetimerange"
                    :range-separator="$t('ticket.datetime.separator')"
                    :start-placeholder="$t('ticket.datetime.start')"
                    :end-placeholder="$t('ticket.datetime.end')"
                    :pickerOptions="pickerOptions"
                    @change="dateChange"
                />
            </div>
            <div class="opeat-r">
                <RangeBox v-if="!islikeLog" @change="getMatchRange"></RangeBox>
                <LangSelect value="all" class="language-select" @change="languageChange" :requireAll="true"></LangSelect>
                <ChannelSelect class="channel-select" value="all" @change="channelChange" />
                <Select initValue="all" :options="quesTypeOptions" class="question-type-select" @menuClick="quesTypeChange" />
                <Select v-if="!islikeLog" initValue="all" :options="answerOptions" class="answer-select" @menuClick="askAnswerChange" />
                <Select v-if="islikeLog" initValue="all" :options="clickIdOptions" class="answer-select" @menuClick="clickIdChange" />
                    <Search :hasInput="true" :placeholder="inputLabel" class="question-search" @searchChange="searchChange" @inputChange="searchChange">
                    <Select
                        :initValue="searchTypeValue"
                        :options="questionOptions"
                        class="question-select"
                        slot="right"
                        @menuClick="searchTypeChange"
                        :topOrBottom="40"
                    />
                </Search>
            </div>
        </div>
    </div>
</template>

<script>
import Search from "@/views/zhiji/bComponents/inputs/Search";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import ChannelSelect from "@/views/zhiji/components/channelSelect/index";
import SingleCalendar from "@/views/zhiji/bComponents/calendar/SingleCalendar";
import LangSelect from "@/components/langSelect";
import RangeBox from "./RangeBox.vue";

import { questionTypeOptions } from "@/views/zhiji/components/pagesPanel/pagesConfig.js";
import { answerOptions, questionOptions, clickIdOptions } from "../askAnswerLogConfig.js";
import { debounce } from "@/views/zhiji/js/common/util.js";

export default {
    name: "LogOperationBar",
    props: ["data", "row", "islikeLog"],
    components: {
        Search,
        Select,
        SingleCalendar,
        ChannelSelect,
        LangSelect,
        RangeBox
    },
    data() {
        return {
            calendarConfig: {
                position: "left",
                hasRadius: true,
                dateFormat: "YYYY/MM/DD hh:mm"
            },
            customDate: {
                startTime: new Date(this.zhiji.dateFormat(new Date(), "YYYY-MM-DD 00:00")),
                endTime: new Date()
            },
            languageValue: "",
            senWordValue: "",
            channelValue: "",
            quesTypeValue: "",
            answerTypeValue: "",
            searchTypeValue: "all",
            clickId: "",
            keyWord: "",
            curPage: 1,
            curPageLen: 10,
            matchData: { start: "", end: "" },
            rangeTip: "请输入0~1范围区间!",
            valueTip: "筛选范围的开始值不能大于结束值哦！",
            disableRanges: [
                {
                    start: new Date(Date.now() + 24 * 60 * 60 * 1000) // 只可选择今天以前的日期
                },
            ],
            dates: [new Date(this.zhiji.dateFormat(new Date(), "YYYY-MM-DD 00:00")), new Date()],
            pickerOptions: {
                disabledDate: time => {
                    return time.getTime() > Date.now();
                },
            }
        };
    },
    computed: {
        quesTypeOptions() {
            return questionTypeOptions();
        },
        answerOptions() {
            return answerOptions();
        },
        questionOptions() {
            return questionOptions();
        },
        clickIdOptions() {
            return clickIdOptions();
        },
        inputLabel() {
            return this.$t("zhiji.common.inputHolderLabel");
        }
    },
    mounted() {
        this.queryHanlder = debounce(() => {
            this.updateLogParams();
        }, 500);
    },
    methods: {
        languageChange(data) {
            data == "all" ? (this.languageValue = "") : (this.languageValue = data);
            this.updateLogParams();
        },
        searchChange(data) {
            this.keyWord = data.value;
            this.queryHanlder();
        },
        channelChange(data) {
            data == "all" ? (this.channelValue = "") : (this.channelValue = data);
            this.updateLogParams();
        },
        quesTypeChange(data) {
            data.value == "all" ? (this.quesTypeValue = "") : (this.quesTypeValue = data.value);
            this.updateLogParams();
        },
        askAnswerChange(data) {
            const answerObj = { noAnswer: "0", hasAnswer: "1", all: "" };
            this.answerTypeValue = answerObj[data.value];
            this.updateLogParams();
        },
        clickIdChange(data) {
            data.value === "all" ? (this.clickId = "") : (this.clickId = data.value);
            this.updateLogParams();
        },
        searchTypeChange(data) {
            this.searchTypeValue = data.value;
            this.$emit("updateSearchType", this.searchTypeValue);
        },
        updateLogParams() {
            let reqData = {
                startDate: this.zhiji.dateFormat(this.customDate.startTime),
                endDate: this.zhiji.dateFormat(this.customDate.endTime),
                curPage: this.curPage,
                size: this.curPageLen,
                channel: this.channelValue,
                questionType: this.quesTypeValue,
                answerType: this.answerTypeValue,
                searchType: this.searchTypeValue,
                keyWord: this.keyWord,
                lang: this.languageValue,
                senWords: this.senWordValue,
                clickId: this.clickId,
                indexScoreMin: this.matchData.start || "",
                indexScoreMax: this.matchData.end || ""
            };
            this.$emit("updateLogData", reqData);
        },
        getMatchRange(range) {
            this.matchData = { ...range };
            if (!this.matchData.start && !this.matchData.end) {
                this.matchData = "";
                this.updateLogParams();
                return;
            }
            debounce(this.getMatchData, 1000)();
        },
        getMatchData() {
            if (this.matchData.start && this.matchData.end) {
                if (!this.isTwoDigit(Number(this.matchData.start)) || !this.isTwoDigit(Number(this.matchData.end))) {
                    this.showTips(this.rangeTip);
                    return;
                }
                if (Number(this.matchData.start) > Number(this.matchData.end)) {
                    this.showTips(this.valueTip);
                    return;
                }
                this.updateLogParams();
                return;
            }
            if (!this.matchData.start) {
                this.matchData.start = 0;
                this.updateLogParams();
                return;
            }
            if (!this.matchData.end) {
                this.matchData.end = 1;
                this.updateLogParams();
            }
        },
        isTwoDigit(param) {
            if (/^0\.[0-9]{1,2}$|^0{1}$|^1{1}$|^1\.[0]{1,2}$/.test(param)) {
                return true;
            }
            return false;
        },
        showTips(message) {
            this.$message({
                message,
                showClose: true,
                type: "error"
            });
        },
        dateChange(date) {
            if (!date.length) return;
            this.customDate = {
                startTime: new Date(this.zhiji.dateFormat(date[0])),
                endTime: new Date(this.zhiji.dateFormat(date[1])),
            };
            this.updateLogParams();
            this.$emit("updateTime", this.customDate);
        }
    }
};
</script>

<style lang="less" scoped>
.operator-bar-wrapper {
    .operator-box {
        padding: 16px 0 6px 0;

        .time-box {
            margin: 0;
            display: inline-block;

            .span-fgf {
                display: inline-block;
                vertical-align: middle;
                background: #e1eaf2;
                width: 12px;
                height: 2px;
                margin: 0 4px;
                position: relative;
                top: -5px;
            }

            .time-start,
            .time-end {
                width: 171px;
                height: 32px;
                margin-bottom: 10px;
                display: inline-block;
            }
        }
    }

    .opeat-l,
    .select-opt,
    .opeat-r {
        display: inline-block;
    }

    .opeat-l {
        margin-top: 6px;
    }

    .opeat-r {
        float: right;
    }

    .language-select,
    .question-type-select,
    .answer-select,
    .question-search,
    .channel-select {
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 10px;
    }
    .channel-select {
        width: 140px;
        margin-right: 8px;
    }
    .question-select {
        border: 0;
        border-right: 1px solid #e3e3e3;
        border-radius: 0;
    }

    .question-search {
        font-size: 14px;
        width: 318px;
        display: inline-flex;
    }

    .language-select {
        width: 120px;
        margin-right: 8px;
    }
}
.clr {
    &:after {
        content: " ";
        clear: both;
        height: 0;
        visibility: hidden;
        display: block;
    }
}
/deep/ .rtl input {
    direction: rtl;
    padding-right: 57px;
}
</style>
